import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { planKindFrom, stashPurchaseIntent } from '../../lib/purchaseIntent.js';

/**
 * Any path → «شروع», for a person with no clinic to enter.
 *
 * Exactly the `<Navigate to="/start">` it replaced, plus one thing: a person who
 * arrived on `/subscription` — the landing sites' «خرید اشتراک», possibly with
 * `?plan=` — is remembered as having come to buy, so the end of onboarding opens
 * «اشتراک» instead of پذیرش (lib/purchaseIntent.js). Every other path drops as
 * it always did; «شروع» is where a person with no clinic belongs.
 *
 * The write sits in an effect, and the location it reads is the one this render
 * saw, so it does not matter that `<Navigate>` below has already moved on.
 */
export default function StartRedirect() {
  const location = useLocation();

  React.useEffect(() => {
    if (location.pathname.replace(/\/+$/, '') !== '/subscription') return;
    stashPurchaseIntent(planKindFrom(location.search));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <Navigate to="/start" replace />;
}
